"use strict";
// @ts-ignore
try {
    self['workbox:google-analytics:5.1.3'] && _();
}
catch (e) { }
